(function () {
  const DEFAULT_TIME_ZONE = 'America/Panama';

  function getDatePartsInTimeZone(timeZone) {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).formatToParts(new Date());

    return parts.reduce((result, part) => {
      if (part.type !== 'literal') result[part.type] = Number(part.value);
      return result;
    }, {});
  }

  function addDays(date, days) {
    const result = new Date(date.getTime());
    result.setUTCDate(result.getUTCDate() + days);
    return result;
  }

  function ordinal(day) {
    if (day >= 11 && day <= 13) return `${day}th`;
    const remainder = day % 10;
    if (remainder === 1) return `${day}st`;
    if (remainder === 2) return `${day}nd`;
    if (remainder === 3) return `${day}rd`;
    return `${day}th`;
  }

  function formatDate(date, format, dayLabels, monthLabels) {
    const dayName = dayLabels[(date.getUTCDay() + 6) % 7] || '';
    const monthName = monthLabels[date.getUTCMonth()] || '';
    const day = date.getUTCDate();
    const numericDay = String(day).padStart(2, '0');
    const numericMonth = String(date.getUTCMonth() + 1).padStart(2, '0');

    switch (format) {
      case 'day_mm_dd':
        return `${dayName}, ${monthName} ${ordinal(day)}`;
      case 'day_dd_mm':
        return `${dayName}, ${day}. ${monthName}`;
      case 'dd_mm':
        return `${day}. ${monthName}`;
      case 'day_dd_mm_numeric':
        return `${dayName}, ${numericDay}. ${numericMonth}.`;
      case 'dd_mm_numeric':
        return `${numericDay}. ${numericMonth}.`;
      case 'mm_dd':
      default:
        return `${monthName} ${ordinal(day)}`;
    }
  }

  function renderContainer(container) {
    const timeZone = container.dataset.timeZone || DEFAULT_TIME_ZONE;
    const todayParts = getDatePartsInTimeZone(timeZone);
    const today = new Date(Date.UTC(todayParts.year, todayParts.month - 1, todayParts.day, 12));
    const format = container.dataset.dateFormat || 'mm_dd';
    const dayLabels = (container.dataset.dayLabels || '').split(',').map((label) => label.trim());
    const monthLabels = (container.dataset.monthLabels || '').split(',').map((label) => label.trim());

    container.querySelectorAll('[data-dynamic-date="true"]').forEach((element) => {
      const template = element.dataset.text || '';
      const minDays = Number.parseInt(element.dataset.minDays || '0', 10);
      const maxDays = Number.parseInt(element.dataset.maxDays || '0', 10);
      const startDate = formatDate(addDays(today, minDays), format, dayLabels, monthLabels);
      const endDate = formatDate(addDays(today, maxDays), format, dayLabels, monthLabels);

      element.innerHTML = template
        .replaceAll('[start_date]', startDate)
        .replaceAll('[end_date]', endDate);
    });
  }

  function renderAll(root) {
    root.querySelectorAll('dynamic-dates[data-time-zone]').forEach(renderContainer);
  }

  function init() {
    renderAll(document);
    window.setInterval(() => renderAll(document), 60 * 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => renderAll(event.target));
})();
